import type { PropsWithChildren } from 'react'

import { useAppSettings, useUserContext } from '@/hooks/settings'

// TODO: Keep route params when redirecting
export const SessionGate = ({ children }: PropsWithChildren) => {
  const contextQuery = useUserContext()
  const settingsQuery = useAppSettings()

  const hasRequiredData = contextQuery.isSuccess && settingsQuery.isSuccess

  return hasRequiredData ? children : null
}
